export class UpdateData {
    static readonly type = '[Realizar request] Update';
}